module.exports = __webpack_public_path__ + "static/img/6553_phase_function_Paper_PointsHejduk_Prediction.2510448.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6553_phase_function_Paper_PointsHejduk_Prediction.png
// module id = LBKx
// module chunks = 0